import React from 'react';
import {Progress, Box, Text, Tooltip, Flex} from "@chakra-ui/react";
import {keyframes} from "@emotion/react";
import {InfoIcon} from "@chakra-ui/icons"; // Import from Emotion for animations

interface ProgressBarProps {
  percentage: number | null; // Percentage value (0-100)
}

// Define keyframes for opacity animation
const fadeAnimation = keyframes`
    0% {
        opacity: 0.5;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0.5;
    }
`;

const ProgressBar: React.FC<ProgressBarProps> = ({percentage}) => {
  const percentageAsNumber: number = percentage ?? 0;
  return (
    <Box w="full">
      {/* Animated text */}
      <Flex className="items-center justify-center gap-2">
        <Text
          className="text-center text-sm mb-1"
          animation={!percentage ? `${fadeAnimation} 1.5s infinite ease-in-out` : "none"}
        >
          {percentageAsNumber}%
        </Text>
      </Flex>
      {/* Progress bar with animation when Transcribing */}
      <Progress
        className="rounded-full"
        value={percentage === null ? undefined : percentage} // Hide value when Transcribing
        isIndeterminate={!percentage} // Makes the progress bar animate
        size="sm"
        bg="gray.700"
        sx={{
          '& > div:first-of-type': {
            backgroundColor: "brandPurple.500",
          },
        }}
      />
    </Box>
  );
};

export default ProgressBar;